const debugEnabled = process.env.VUE_APP_DEBUG === 'true'

export function debugLog(...args: unknown[]): void {
  if (debugEnabled) {
    // eslint-disable-next-line no-console
    console.log(...args)
  }
}
